import { RouteObject } from 'react-router-dom'

export const agentRoute: RouteObject[] = [
  {
    path: 'agents/list',
    lazy: async () => ({
      Component: (await import('@/pages/agents/index.tsx')).default,
    }),
  },
  {
    path: 'tasks-assignments/list',
    lazy: async () => ({
      Component: (await import('@/pages/projects/tasks-assignments/index.tsx')).default,
    }),
  },
]
